/* =========================================================================
   MADHOURS - sticky mobile add-to-cart bar. Product pages, phones only.

   Why: the buy button now sits high in the column, so it scrolls out of view
   long before a shopper finishes the bundle, trust row, description, accordion
   and recommendations. Every competitor in the teardown ships a fixed bar.

   Self-contained on purpose - styles, markup and behaviour live here so the
   45KB PDP section never has to be touched. It owns no buy logic: the bar
   forwards a tap to the real add-to-cart button, so variant, quantity and
   bundle state stay owned by the existing form.

   NOTE: the bundle app re-renders the add-to-cart area after load, which
   detaches any node captured at startup (a detached node never intersects,
   so an IntersectionObserver on it silently stops firing). Everything below
   therefore RE-QUERIES the button on each tick instead of holding a reference.
   ========================================================================= */
(function () {
  'use strict';

  var SEL = '[data-node-type="commerce-add-to-cart-button"]';

  function realBtn() {
    var b = document.querySelector(SEL);
    return b && b.isConnected ? b : null;
  }

  // Nothing to shortcut to on a sold-out product.
  if (!realBtn()) return;

  var titleEl = document.querySelector('.product-content-box .product-title');
  var priceEl = document.querySelector('#product-price-section-2');
  var imgEl = document.querySelector('#main-product-image, .featured-product-image img');

  var css = [
    '.mh-sticky{display:none}',
    '@media (max-width:900px){',
    '.mh-sticky{',
      'position:fixed;left:0;right:0;bottom:0;z-index:60;',
      'display:flex;align-items:center;gap:12px;',
      'padding:10px 14px calc(10px + env(safe-area-inset-bottom));',
      'background:#fff;border-top:1px solid rgba(0,0,0,.15);',
      'transform:translateY(115%);transition:transform .25s ease;',
      'will-change:transform;',
    '}',
    '.mh-sticky--on{transform:translateY(0)}',
    '.mh-sticky__img{width:40px;height:40px;object-fit:cover;flex:0 0 auto;border:1px solid rgba(0,0,0,.15)}',
    '.mh-sticky__txt{display:flex;flex-direction:column;gap:2px;min-width:0}',
    '.mh-sticky__name{font-size:10px;letter-spacing:.14em;text-transform:uppercase;',
      'white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:#000}',
    '.mh-sticky__price{font-size:12px;font-weight:700;letter-spacing:.02em;color:#000}',
    '.mh-sticky__info{display:flex;align-items:center;gap:10px;min-width:0;flex:1 1 auto}',
    '.mh-sticky__btn{',
      'flex:0 0 auto;min-height:46px;padding:0 26px;',
      'background:#000;color:#fff;border:1px solid #000;border-radius:0;cursor:pointer;',
      'font-family:inherit;font-size:12px;font-weight:700;letter-spacing:.18em;text-transform:uppercase;',
      '-webkit-tap-highlight-color:transparent;transition:transform .1s ease;',
    '}',
    '.mh-sticky__btn:active{transform:scale(.97)}',
    '.mh-sticky__btn:focus-visible{outline:2px solid #000;outline-offset:3px}',
    '}',
    '@media (prefers-reduced-motion:reduce){',
    '.mh-sticky,.mh-sticky__btn{transition:none}',
    '}'
  ].join('');

  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  var bar = document.createElement('div');
  bar.className = 'mh-sticky';

  var info = document.createElement('div');
  info.className = 'mh-sticky__info';

  if (imgEl && (imgEl.currentSrc || imgEl.src)) {
    var thumb = document.createElement('img');
    thumb.className = 'mh-sticky__img';
    thumb.src = imgEl.currentSrc || imgEl.src;
    thumb.alt = '';
    thumb.setAttribute('aria-hidden', 'true');
    info.appendChild(thumb);
  }

  var txt = document.createElement('div');
  txt.className = 'mh-sticky__txt';
  var name = document.createElement('span');
  name.className = 'mh-sticky__name';
  name.textContent = titleEl ? titleEl.textContent.trim() : '';
  var price = document.createElement('span');
  price.className = 'mh-sticky__price';
  price.textContent = priceEl ? priceEl.textContent.trim() : '';
  txt.appendChild(name);
  txt.appendChild(price);
  info.appendChild(txt);

  var go = document.createElement('button');
  go.type = 'button';
  go.className = 'mh-sticky__btn';
  go.textContent = ((realBtn() || {}).value || 'Add to cart').trim();
  go.setAttribute('aria-label', go.textContent + ' - ' + name.textContent);

  bar.appendChild(info);
  bar.appendChild(go);
  document.body.appendChild(bar);

  // Forward the tap to whichever button is live right now.
  go.addEventListener('click', function () {
    var b = realBtn();
    if (b) b.click();
  });

  // Show once the real button has scrolled off the top; keep the label in sync
  // (the bundle widget rewrites it). Re-queried every tick so an app re-render
  // can never orphan us. rAF-throttled, listeners passive.
  var ticking = false;
  function sync() {
    ticking = false;
    var b = realBtn();
    if (!b) return;
    var r = b.getBoundingClientRect();
    // past = the button has left the top of the viewport
    var past = r.bottom < 0;
    bar.classList.toggle('mh-sticky--on', past);
    var v = (b.value || '').trim();
    if (v && v !== go.textContent) {
      go.textContent = v;
      go.setAttribute('aria-label', v + ' - ' + name.textContent);
    }
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(sync);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  sync();
})();
